export const KHASRA_NUMBER_REGEX = /^[^\sa-zA-Z]+-[^\sa-zA-Z]+$/;

export const MESSAGES = {
  INVALID_KHASRA_NUMBER_INPUT: "please enter valid format."
}